import { isDateString } from "./isDateString"

const dateReviver = (_key: string, value: unknown): unknown => {
  if (!isDateString(value)) {
    return value
  }

  return new Date(value)
}

export const parseJSON = (text: string): unknown => {
  return JSON.parse(text, dateReviver)
}
